import React from "react";
import "./NotFound.scss";

export default function NotFound() {
  return (
    <div className="notfound">
      <h1>404</h1>
      <h2>Page Not Found</h2>
      <a href="/">Go Back Home</a>
    </div>
  );
}
